// Centralized configuration for the application
// All environment variables are accessed through this config file

const config = {
  // Backend API
  backendUrl: process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001',
  
  // House Call Pro Integration
  hcp: {
    scriptUrl: process.env.REACT_APP_HCP_SCRIPT_URL || 'https://online-booking.housecallpro.com/script.js?token=0c437c2d86c9419abe9d87aaf556b2ec&orgName=Up-Cleaning-Service',
    bookingUrl: process.env.REACT_APP_HCP_BOOKING_URL || 'https://book.housecallpro.com/lead-form/Up-Cleaning-Service/0c437c2d86c9419abe9d87aaf556b2ec'
  },
  
  // Assets
  assets: {
    baseUrl: process.env.REACT_APP_ASSETS_BASE_URL || 'https://customer-assets.emergentagent.com/job_tidyteam/artifacts',
    logos: {
      vertical: `${process.env.REACT_APP_ASSETS_BASE_URL || "https://customer-assets.emergentagent.com/job_tidyteam/artifacts"}/ccl9kjk3_UPCLEANINGPRO%20-%20VERTICAL-01.png`,
      horizontal: `${process.env.REACT_APP_ASSETS_BASE_URL || "https://customer-assets.emergentagent.com/job_tidyteam/artifacts"}/fols0yvr_UPCLEANINGPRO%20-%20Principal%20-%20Negativo-01.png`,
      horizontalLarge: `${process.env.REACT_APP_ASSETS_BASE_URL || "https://customer-assets.emergentagent.com/job_tidyteam/artifacts"}/33upff7k_UPCLEANINGPRO-01%20%282%29.png`,
      icon: `${process.env.REACT_APP_ASSETS_BASE_URL || "https://customer-assets.emergentagent.com/job_tidyteam/artifacts"}/7d0vsldv_UPCLEANINGPRO%20-%20ICONE-01.png`,
      negative: `${process.env.REACT_APP_ASSETS_BASE_URL || "https://customer-assets.emergentagent.com/job_tidyteam/artifacts"}/nbce78zm_UPCLEANINGPRO%20-%20ASSETS%20-%20NEGATIVO-01.png`
    },
    images: {
      heroImage: `${process.env.REACT_APP_ASSETS_BASE_URL || "https://customer-assets.emergentagent.com/job_tidyteam/artifacts"}/p9lcx5dr_WhatsApp%20Image%202025-10-20%20at%2014.24.43_868a5252.jpg`
    }
  },
  
  // Contact Information
  contact: {
    phone: process.env.REACT_APP_PHONE || '+12676134373',
    phoneDisplay: process.env.REACT_APP_PHONE_DISPLAY || '(267) 613-4373',
    email: process.env.REACT_APP_EMAIL || 'scheduleup@upcleaning.pro',
    serviceAreas: [
      'South Jersey',
      'North Delaware',
      'Atlantic City to Cape May',
      'Southeastern PA',
      'Philadelphia, Bucks, Delaware & Montgomery Counties'
    ]
  },
  
  // Social Media
  social: {
    facebook: process.env.REACT_APP_FACEBOOK_URL || 'https://www.facebook.com/p/Up-Cleaning-100083400694071/',
    instagram: process.env.REACT_APP_INSTAGRAM_URL || 'https://www.instagram.com/upcleaning.pro/'
  },
  
  // Stats Base Date
  stats: {
    baseDate: process.env.REACT_APP_STATS_BASE_DATE || '2025-11-05'
  },
  
  // Company Information
  company: {
    name: 'Up Cleaning Pro',
    slogan: 'Tidy Space. Happy Mind!',
    description: 'Professional Cleaning Services',
    locations: 'Philadelphia • South Jersey • Delaware'
  }
};

export default config;
